import { DateRange } from 'react-day-picker';

import { toast } from 'material-react-toastify';

import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { sessionKeys } from '@/lib/query/keys/sessions';
import { SessionHub } from '@addmile/backend-client';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

import { prepareDateRange } from '../utils/utils';

export const useSessions = (coachIds: string[], dates?: DateRange) => {
  return useQuery<SessionHub[]>({
    queryKey: sessionKeys.byCoach(coachIds, dates),
    queryFn: async () => {
      try {
        const token = await getAuthToken();
        if (!coachIds.length) {
          Sentry.captureException('No coach ids provided');
          return [];
        }
        const dateRange = prepareDateRange(dates ?? null);
        const { data: sessions } = await hubApi.getSessionsHub(
          undefined,
          coachIds,
          dateRange.from ?? undefined,
          dateRange.to ?? undefined,
          withAuthHeader(token),
        );

        return sessions.sessions.filter((session) => session.bookedAt);
      } catch (error) {
        Sentry.captureException(`Failed to fetch sessions: ${error.message}`);
        toast.error(`Failed to fetch sessions: ${error.message}`);
        return [];
      }
    },
    enabled: coachIds.length > 0,
    staleTime: 60 * 1000,
  });
};
